import React from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { IWeekModalParams, IWeekModalSaveParams } from 'src/mobx/modalStore/types';
import { formatDate } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { fullWeek } from '~/constants/dateTime';
import './style.scss';

interface IProps extends IWeekModalParams {
  placeholder?: string;
  className?: string;
  titleClassName?: string;
  iconSize?: number;
}

interface IState {
  placeholder: string;
  loading: boolean;
}

export default class WeekModalOpen extends React.Component<IProps, IState> {
  state = {
    placeholder: localeStore.t('choose_date_and_time'),
    loading: false,
  };

  componentDidMount = () => {
    this.changePlaceholder({
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      startTime: this.props.allDay ? undefined : this.props.startTime || undefined,
      endTime: this.props.allDay ? undefined : this.props.endTime || undefined,
    });
  };

  componentDidUpdate = (props: any) => {
    if (this.props !== props)
      this.changePlaceholder({
        startDate: this.props.startDate,
        endDate: this.props.endDate,
        startTime: this.props.allDay ? undefined : this.props.startTime || undefined,
        endTime: this.props.allDay ? undefined : this.props.endTime || undefined,
      });
  };

  changePlaceholder = (data: {
    startDate: IWeekModalSaveParams['startDate'];
    endDate: IWeekModalSaveParams['endDate'];
    startTime: IWeekModalSaveParams['startTime'];
    endTime: IWeekModalSaveParams['endTime'];
  }) => {
    if (data.startDate && data.endDate) {
      const startDate: string = formatDate(data.startDate);
      const endDate: string = formatDate(data.endDate);

      if (data.startTime && data.endTime) {
        this.setState({
          placeholder: `${startDate}, ${formatDate(data.startTime, { onlyTime: true })} –
          ${endDate}, ${formatDate(data.endTime, { onlyTime: true })} `,
        });
        return;
      }
      this.setState({ placeholder: startDate + ' – ' + endDate });
      return;
    }
    this.setState({ placeholder: localeStore.t('choose_date_and_time') });
  };

  clickSave = (data: IWeekModalSaveParams) => {
    this.props.onSave(data);
    this.changePlaceholder(data);
    modalStore.closeWeekModal();
  };

  clickReset = () => {
    const data: IWeekModalSaveParams = {
      startDate: undefined,
      endDate: undefined,
      startTime: undefined,
      endTime: undefined,
      allDay: true,
      daysOfWeek: fullWeek,
    };
    this.props.onSave(data);
    this.changePlaceholder(data);
  };

  onClick = () => {
    modalStore.openWeekModal({
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      startTime: this.props.startTime || undefined,
      endTime: this.props.endTime || undefined,
      allDay: this.props.allDay,
      daysOfWeek: this.props.daysOfWeek,
      timeByDays: this.props.timeByDays,
      validateTime: this.props.validateTime,
      messageOnError: this.props.messageOnError,
      title: this.props.title,
      //
      onSave: this.clickSave,
      timePickerMode: this.props.timePickerMode,
      hideAdditionalSettings: this.props.hideAdditionalSettings,
      minimumOneDayInWeek: this.props.minimumOneDayInWeek,
    });
  };
  render() {
    return (
      <div className={`week-modal-open ${this.props.className || ''}`}>
        <div className="d-flex flex-row full-width pl-3" onClick={this.onClick}>
          <Icon name={Icons.DateTime} color={theme.colors.mainblue} size={18} className="mr-3" />
          <p className={`family-medium text-size-16 color-dark ${this.props.titleClassName || ''}`}>
            {this.props.placeholder || this.state.placeholder}
          </p>
        </div>
        {this.props.startDate || this.props.endDate ? (
          <button onClick={this.clickReset} className="full-height m-0 p-2">
            <Icon name={Icons.CloseSmall} size={16} className="color-gray2" />
          </button>
        ) : null}
      </div>
    );
  }
}
